export const classeParaLabelsFormularioComFundoEscuroSimplificada = 
`
[&>label]:_p-[6px] 
[&>label]:_mb-[0px]
[&>label]:_mt-[0px]
[&>label]:_ml-[0px]
[&>label]:_mr-[0px]
[&>label]:_bg-[#e4e6e8]
[&>label]:_w-[192px] 
[&>label]:text-right

[&>span]:text-left
[&>span]:_p-[6px] 

[&>div]:_p-[6px] 
;
`


export const classeParaLabelsFormularioComFundoEscuro = `[&>label]:_bg-[#e4e6e8] [&>label]:_mb-[-5px] 
[&>label]:_pb-[5px] [&>label]:_pr-[10px]`